import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import DocumentViewer from '../components/DocumentViewer';

const SignDocumentPage: React.FC = () => {
    const { eSignHash } = useParams<{ eSignHash: string }>();
    const history = useHistory();

    return (
        <DocumentViewer
            eSignHash={eSignHash}
            isOpen={true}
            onClose={() => {
                // Redirect to home or any other appropriate page
                history.push('/');
            }}
        />
    );
};

export default SignDocumentPage;
